import Format from 'app/src/data/Format';
import Payment from 'app/src/data/models/Payment';
import PaymentType from 'app/src/data/models/PaymentType';
import Localize from 'app/src/localize/Localize';
import PaymentTypeManager from 'app/src/payments/PaymentTypeManager';
import BaseCollectionView from 'app/src/views/base/BaseCollectionView';
import PaymentListPaymentView from 'app/src/views/payments/PaymentListPaymentView';

// configure
let View = BaseCollectionView.extend({
  childView: PaymentListPaymentView,
  childViewEventPrefix: 'payment',

  tagName: 'table',
  id: 'emv_payments_list',
  className: 'emv-payments',
});

// define
export default class PaymentListView extends View {
  /**
   * Invoked by Marionette to pass options to the
   * @returns {{hideRemoveButton: *}}
   */
  childViewOptions() {
    // pass the hide remove button option to the children
    let viewData = this.viewData || {};
    viewData.hideRemoveButton = this.options.hideRemoveButton;
    viewData.disableRemoveButton = this.options.disableRemoveButton;
    viewData.controller = this.options.controller;
    return {
      viewData,
    };
  }

  /**
   * Event handler called before the view is rendered.
   */
  onBeforeRender() {
    // Attach a Handlebars helper to break at ever 4th currency denomination
    window.Handlebars.registerHelper(
      'debitCreditOrGiftCard',
      (model, details = null, depositPayment = null) => {
        let outputString = '';
        let workingModel = model;
        let type = Localize.translate('Credit Card');

        if (depositPayment) {
          outputString += Localize.translate('Deposit Refund - ');
          workingModel = depositPayment.model;
        }

        if (!workingModel.PaymentType) {
          // We don't have the Payment Type because it was archived,
          // or because something weird happened.
          workingModel.PaymentType = PaymentTypeManager.getPaymentType(
            workingModel.paymentTypeID,
            true
          ).toJSON();
        }

        if (workingModel.PaymentType.code === PaymentType.Types.CREDIT_CARD) {
          if (details && details.isDebit) {
            type = Localize.translate('Debit');
          }
        } else if (workingModel.PaymentType.name) {
          type = Localize.translate(workingModel.PaymentType.name);
        }

        let cardNumber = '';
        if (workingModel.cardNumber) {
          cardNumber = ` (${workingModel.cardNumber})`;
        }

        return new window.Handlebars.SafeString(`${outputString}${type}${cardNumber}`);
      }
    );

    window.Handlebars.registerHelper(
      'cardInformation',
      (model, details = null, depositPayment = null) => {
        let cardInformation = '';
        if (model.PaymentType.type === PaymentType.Types.CREDIT_CARD) {
          if (details && !depositPayment) {
            if (details.cardType) {
              cardInformation += `${details.cardType}`;
            }
            if (details.maskedDigits) {
              cardInformation += ` (${details.maskedDigits || XXXX})`;
            }
          }
        }

        return new window.Handlebars.SafeString(cardInformation);
      }
    );

    window.Handlebars.registerHelper('visiblePaymentAmount', (model) => {
      let paymentAmount = Format.parseMoney(model.amount, 0);
      if (model.PaymentType.type === PaymentType.Types.GIFT_CARD) {
        // gift card payments are always displayed as positive values in
        // the listing UI
        paymentAmount = paymentAmount.abs();
      }

      return new window.Handlebars.SafeString(Format.formatMoney(paymentAmount));
    });

    window.Handlebars.registerHelper('shouldHideRemoveButton', (model, viewData) => {
      let hideRemoveButton = false;

      if (viewData.hideRemoveButton) {
        hideRemoveButton = model.PaymentType.type === PaymentType.Types.CREDIT_CARD;
      } else if (viewData.details && viewData.details.operationType) {
        hideRemoveButton = viewData.details.operationType === Payment.OperationType.REFUND;
      }

      return hideRemoveButton;
    });

    window.Handlebars.registerHelper(
      'shouldDisableRemoveButton',
      (model, viewData) =>
        viewData.disableRemoveButton &&
        ![PaymentType.Types.CREDIT_CARD, PaymentType.Types.GIFT_CARD].includes(
          model.PaymentType.type
        )
    );
  }

  /**
   * Event handler called before the view is destroyed.
   */
  onBeforeDestroy() {
    window.Handlebars.unregisterHelper('debitCreditOrGiftCard');
    window.Handlebars.unregisterHelper('cardInformation');
    window.Handlebars.unregisterHelper('visiblePaymentAmount');
    window.Handlebars.unregisterHelper('shouldHideRemoveButton');
  }
}
